import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GridFilterModel } from "@mui/x-data-grid-pro";
import { and, or } from "@/Common/helpers/sonar";

export interface ITableFilterRecordType {
	key: string;
	persistAcrossLocations: boolean;
	persistAcrossRouteChange: boolean;
	filterModel: GridFilterModel;
}

const actionNames = {
	deleteMultipleFilters: "DELETE_MULTIPLE_FILTERS",
	deleteSingleFilter: "DELETE_SINGLE_FILTER",
	updateFilter: "UPDATE_FILTER",
} as const;

const tableFilterSlice = createSlice({
	initialState: {} as Record<string, ITableFilterRecordType | undefined | null>,
	name: "TableFilter",
	reducers: {
		[actionNames.deleteMultipleFilters]: (state, { payload: reason }: PayloadAction<"locationChange" | "routeChange">) => {
			Object.keys(state).forEach((key) => {
				const filter = state[key];
				if (!filter) {
					return;
				}

				if (
					or(
						and(filter?.persistAcrossLocations, reason === "locationChange"),
						and(filter?.persistAcrossRouteChange, reason === "routeChange")
					)
				) {
					return;
				}
				state[key] = null;
			});
		},
		[actionNames.deleteSingleFilter]: (state, { payload }: PayloadAction<string>) => {
			state[payload] = null;
			return state;
		},
		[actionNames.updateFilter]: (state, { payload }: PayloadAction<ITableFilterRecordType>) => {
			const { key, filterModel } = payload;
			if (key && filterModel) {
				state[key] = payload;
			}
		},
	},
});

export const { actions } = tableFilterSlice;
export default tableFilterSlice.reducer;
